import { render, staticRenderFns } from "./dps.vue?vue&type=template&id=1331cebc"
import script from "./dps.vue?vue&type=script&lang=js"
export * from "./dps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports